<template>
  <div>
    <transition name="slide-left">
      <div v-if="welcome_message" class="welcome-message">
        <Welcome
          @openMenu="welcome_message = false"
          :lang="this.$route.query.lang"
        />
      </div>
    </transition>
    <transition name="slide-left">
      <div v-if="!welcome_message" class="page-content">
        <nav style="height: 5rem" class="navbar bg-light fixed-top">
          <div class="container-fluid">
            <nav class="navbar bg-light">
              <div class="container">
                <router-link
                  :to="{
                    name: 'Categories',
                    query: { lang: this.$route.query.lang },
                  }"
                  aria-current="page"
                >
                  <img
                    class="mado_logo"
                    src="../public/img/madoyenilogo.jpeg"
                    alt="MADO"
                  />
                </router-link>
              </div>
            </nav>
            <button
              ref="navbarToggler"
              class="navbar-toggler"
              type="button"
              data-bs-toggle="offcanvas"
              data-bs-target="#offcanvasNavbar"
              aria-controls="offcanvasNavbar"
            >
              <span class="navbar-toggler-icon"></span>
            </button>
            <div
              class="offcanvas offcanvas-end"
              tabindex="-1"
              id="offcanvasNavbar"
              aria-labelledby="offcanvasNavbarLabel"
              style="background-color: #354b7c"
            >
              <div class="offcanvas-header">
                <h5
                  class="offcanvas-title"
                  id="offcanvasNavbarLabel"
                  style="color: #fefefe"
                >
                  MADO
                </h5>
                <button
                  type="button"
                  class="btn-close"
                  data-bs-dismiss="offcanvas"
                  aria-label="Close"
                ></button>
              </div>
              <div class="offcanvas-body">
                <ul class="list-group list-group-flush">
                  <li class="list-group-item">
                    <router-link
                      :to="{
                        name: 'Categories',
                        query: { lang: this.$route.query.lang },
                      }"
                      @click="closeMenu"
                      class="nav-link"
                      >{{ home[this.$route.query.lang] }}</router-link
                    >
                  </li>
                  <li class="list-group-item">
                    <router-link
                      :to="{
                        name: 'AllergenTable',
                        query: { lang: this.$route.query.lang },
                      }"
                      @click="closeMenu"
                      class="nav-link"
                      >{{ allergen[this.$route.query.lang] }}</router-link
                    >
                  </li>
                  <li class="list-group-item">
                    <a
                      style="text-decoration: none; color: inherit"
                      :href="`https://www.madobelgium.be/?lang=${this.$route.query.lang}`"
                      target="_blank"
                      >{{ about[this.$route.query.lang] }}</a
                    >
                  </li>
                  <li class="nav-item dropdown">
                    <a
                      class="nav-link dropdown-toggle"
                      href=""
                      role="button"
                      data-bs-toggle="dropdown"
                      aria-expanded="false"
                      style="color: #fefefe"
                    >
                      <img
                        src="../public/img/icons8-globe-50.png"
                        style="width: 1.5rem; margin-bottom: 1%"
                        alt="language icon"
                      />
                      {{ taal[this.$route.query.lang] }}
                    </a>
                    <ul class="dropdown-menu dropdown-menu-dark">
                      <li>
                        <router-link
                          :to="{
                            name: this.$options.name,
                            query: { lang: 'nl' },
                          }"
                          @click="closeMenu"
                          class="nav-link"
                        >
                          <a class="dropdown-item"
                            >Nederlands
                            <img
                              class="language-icon"
                              src="../public/img/icons8-belgium-48.png"
                              alt="Belgie"
                            />
                          </a>
                        </router-link>
                      </li>
                      <!-- <li>
                    <hr class="dropdown-divider" />
                  </li>
                  <li>
                    <router-link
                      :to="{ name: this.$options.name, query: { lang: 'en' } }"
                      @click="closeMenu"
                      class="nav-link"
                    >
                      <a class="dropdown-item" href=""
                        >English
                        <img
                          class="language-icon"
                          src="../public/img/icons8-great-britain-48.png"
                          alt="Belgie"
                        />
                      </a>
                    </router-link>
                  </li> -->
                    </ul>
                  </li>
                </ul>
              </div>
            </div>
          </div>
        </nav>
        <router-view />
        <div class="footer">
          <div class="footer-right">
            <div class="socials">
              <a
                href="https://m.facebook.com/madobelgium/"
                target="_blank"
                rel="nofollow"
              >
                <img
                  src="https://img.icons8.com/color/48/null/facebook-new.png"
                  alt="social media icon"
                />
              </a>
              <a
                href="https://www.instagram.com/madoheusden/"
                target="_blank"
                rel="nofollow"
                style="padding-left: 5%"
              >
                <img
                  src="https://img.icons8.com/fluency/48/null/instagram-new.png"
                  alt="social media icon"
                />
              </a>
              <a
                href="https://www.youtube.com/channel/UChkyVqU0YsUKaxuMXCO0Mlg"
                target="_blank"
                rel="nofollow"
                style="padding-left: 5%"
              >
                <img
                  src="https://img.icons8.com/color/48/null/youtube-play.png"
                  alt="social media icon"
                />
              </a>
            </div>
          </div>
          <div class="footer-left" style="font-size: 14px">
            {{ copyright[this.$route.query.lang] }}
          </div>
        </div>
      </div>
    </transition>
  </div>
</template>

<script>
import Welcome from "./components/Welcome.vue";

export default {
  components: {
    Welcome,
  },

  methods: {
    closeMenu: function () {
      this.$refs.navbarToggler.click();
    },
  },

  mounted() {
    // setTimeout(() => {
    //   if (!this.welcome_message) {
    //     this.$refs.carousel_control_next.click();
    //   }
    // }, 3000);
  },

  data() {
    return {
      welcome_message: true,
      home: {
        nl: "Startpagina",
        en: "Home",
        tr: "Ana Sayfa",
      },
      allergen: {
        nl: "Allergenentabel",
        en: "Allergen Table",
        tr: "Alerjen Tablosu",
      },
      about: {
        nl: "Over MADO",
        en: "About MADO",
        tr: "MADO hakkında",
      },
      taal: {
        nl: "Taal",
        en: "Language",
        tr: "Dil",
      },
      warning: [
        {
          nl: "Beste klant,",
          en: "Dear guest,",
          tr: "Sayın müşterimiz,",
        },
        {
          nl: "Het ontbijt wordt geserveerd van 10:00 tot 12:30 uur.",
          en: "Breakfast is served from 10:00 until 12:30.",
          tr: "Kahvaltı servisimiz saat 10:00'dan 12:30'a kadar sürmektedir.",
        },
        {
          nl: "Warme gerechten worden geserveerd van 12:30 tot 21:00 uur.",
          en: "Warm dishes are served from 12:30 until 21:00.",
          tr: "Sıcak yemek servisimiz saat 12:30'dan 21:00'a kadar sürmektedir.",
        },
      ],
      copyright: {
        nl: "© 2022 MADO is een Yaşar Ice Cream ve Gıda Maddeleri A.Ş. corporatie",
        en: "© 2022 MADO is a Yaşar Dondurma ve Gıda Maddeleri A.Ş. corporation.",
        tr: "© 2022 MADO Bir Yaşar Dondurma ve Gıda Maddeleri A.Ş. kuruluşudur.",
      },
    };
  },
};
</script>

<style>
.welcome-message {
  height: 100vh;
  display: flex;
  align-items: center;
  justify-content: center;
  background: #354b7c;
  color: #fefefe;
}

.d-block {
  height: 250px; /* height of container */
  padding-top: 18%;
  object-fit: cover;
}

#nav {
  background-color: #354b7c;
}

.carousel-inner {
  margin-bottom: 5% !important;
}
#app {
  font-family: Avenir, Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  text-align: center;
  color: #354b7c;
}

#nav {
  padding: 30px;
}

#nav a {
  font-weight: bold;
  color: #2c3e50;
}

.mado_logo {
  width: 5rem;
  margin-right: 70%;
}

.container-fluid {
  flex-wrap: nowrap !important;
}

.list-group-item {
  background-color: inherit;
  color: #fefefe;
  border: 1px solid;
  text-align: left;
}

.offcanvas {
  max-width: 80%;
}

#nav a {
  color: #fefefe;
}

.dropdown-menu.show {
  background-color: #fefefe;
}

.dropdown-item {
  color: #354b7c !important;
  display: inline;
}

.dropdown-menu[data-bs-popper] {
  position: absolute;
  left: 50%;
  margin-right: -50%;
  transform: translate(-50%);
}

.dropdown {
  padding-top: 8%;
}

.language-icon {
  width: 18%;
  float: right;
}

.user-warning {
  width: 80%;
  display: flex;
  justify-content: center;
  flex-direction: column;
  align-items: center;
  margin-left: 10%;
  background-color: #f7f4f4;
  border-radius: 15px;
  padding: 5%;
}

.footer {
  background-color: #354b7c;
  color: #fefefe;
  display: grid;
  justify-content: center;
  align-items: center;
  padding: 5%;
}

.socials a img {
  width: 8%;
}

.socials {
  margin-bottom: 5%;
}

/* Animations */

.slide-left-enter-active,
.slide-left-leave-active {
  transition: all 0.5s ease;
}

.slide-left-enter,
.slide-left-leave-to {
  transform: translateX(-80%);
}
</style>
